<template>
  <div>
    <div class="home" v-if="isPhone">
      <div class="banner">
        <van-swipe class="my-swipe" indicator-color="white" autoplay="5000">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <img
              @click="goUrl(item)"
              :src="IMAGE_API + item.thumbnail"
              alt=""
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <van-tabs
        v-model="active"
        color="#0095ff"
        title-active-color="#0095ff"
        title-class="tabwaper"
        @click="onClickTab($event)"
        sticky
      >
        <van-tab title="推荐">
          <!-- van-tab van-tab--active -->
          <meetList :isTop="isTop" :time="time" :type="'fire'"></meetList>
        </van-tab>
        <van-tab title="全站" >
          <div class="subBtns">
            <div
              class="subBtn today"
              :class="{ 'subBtn--active': selectBtn == 1 }"
              @click="onlyToDay(1)"
            >
              <img v-if="selectBtn == 1" :src="jb" alt="" />
              <img v-else :src="j" alt="" />
              仅看今日
            </div>
            <div
              class="subBtn tomorrow"
              :class="{ 'subBtn--active': selectBtn == 2 }"
              @click="onlyTomorrow(2)"
            >
              <img v-if="selectBtn == 2" :src="mb" alt="" />
              <img v-else :src="m" alt="" />
              仅看明日
            </div>
            <div
              class="subBtn seeback"
              :class="{ 'subBtn--active': selectBtn == 3 }"
              @click="onlyBack(3)"
            >
              <img v-if="selectBtn == 3" :src="backb" alt="" />
              <img v-else :src="back" alt="" />
              直播回顾
            </div>
          </div>
          <meetList
            :isTop="isTop"
            :time="time"
            :threeOptionsIndex="threeOptionsIndex"
            :type="'all'"
          ></meetList>
        </van-tab>

      </van-tabs>
      <transition name="fade">
        <!--          v-show="showMaskButton" -->
        <div
          :class="showMaskButton ? 'cooperation' : 'transright'"
          @click="showMask = true"
        >
          <img :src="cooperation" alt="" />
        </div>
      </transition>
      <van-popup
        v-model="showMask"
        round
        position="bottom"
        :style="{ height: '25%' }"
      >
        <p class="swhz">商务合作</p>
        <p class="num">021-64680720</p>
        <a href="tel:021-64680720">
          <img class="phoneImg" :src="phone" alt="" />
        </a>
      </van-popup>
    </div>
    <div v-else>
      <div class="pc">
        <div class="nav">
          <div class="nav_left">
            <div class="logo">
              <img :src="logo" alt="" />
            </div>
            <div class="line"></div>
            <div class="title">医道专业学习平台</div>
          </div>
          <div class="nav_right" @click="backUrl">
            <div class="back" @mouseleave="leave($event)">
              回到医道官网
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
        <div class="banner" v-if="bannerList.length > 0">
          <topswiper :imgs="bannerList" @toLive="goUrl(item)"></topswiper>
        </div>
        <main>
          <div class="meetList">
            <div class="left" :class="leftMenu ? 'leftMenu' : ''">
              <div
                class="left_item"
                :class="{ left_item_active: selectIndex == 0 }"
                @click="filterMeet(0)"
                @mouseleave="leave($event)"
              >
                <p>全部直播</p>
              </div>
              <div
                class="left_item left_hover"
                :class="{ left_item_active: selectIndex == 4 }"
                @click="filterMeet(4)"
                @mouseleave="leave($event)"
              >
                <p>推荐直播</p>
                <!-- <img src="../assets/newIcon/hot.gif" class="fire" alt=""> -->
              </div>
              <div
                class="left_item left_hover"
                :class="{ left_item_active: selectIndex == 1 }"
                @click="filterMeet(1)"
                @mouseleave="leave($event)"
              >
                <p>{{ today }} <img :src="jc" alt="" /></p>
                <span>{{ jWeek }}</span>
              </div>
              <div
                class="left_item left_hover"
                :class="{ left_item_active: selectIndex == 2 }"
                @click="filterMeet(2)"
                @mouseleave="leave($event)"
              >
                <p>{{ tomorrow }}</p>
                <span>{{ mWeek }}</span>
              </div>
              <div
                class="left_item left_hover"
                :class="{ left_item_active: selectIndex == 3 }"
                @click="filterMeet(3)"
                @mouseleave="leave($event)"
              >
                <p>{{ afterTomorrow }}</p>
                <span>{{ hWeek }}</span>
              </div>
            </div>
            <div class="right" id="right" :class="leftMenu ? 'rightMar' : ''">
              <meetListPc
                :tabIndex="tabIndex"
                :selcetDate="selcetDate"
                :isTopPc="isTopPc"
              ></meetListPc>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="backTop" v-if="!isPhone">
      <div class="toTop" id="toTop" @click="backToTop">
        <img :src="toTop" alt="" />
      </div>
      <div class="qr">
        <img :src="qr" alt="" />
        <div class="show">
          <div class="hoverdiv">
            <div>
              <img :src="wxqr" alt="" />
              <p>微信公众号</p>
            </div>
            <div>
              <img :src="dyqr" alt="" />
              <p>抖音公众号</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import meetList from "../components/meetinglist.vue";
import meetListPc from "../components/meetinglistpc.vue";
import { getBanner, addClickCount } from "../request/request";
import { IMAGE_API } from "../request/api";
import { isMobile, transTimestamp } from "@/utils/tool";
import topswiper from "../components/topswiper.vue";
import { getMeetingList } from "../request/request";
import moment from "moment";
export default {
  components: { meetList, meetListPc, topswiper },
  data() {
    const cooperation = require("../assets/images/home/cooperation1.png");
    const phone = require("../assets/images/home/phone.png");
    const logo = require("../assets/images/home/logo.png");
    const j = require("../assets/newIcon/j.png");
    const m = require("../assets/newIcon/m.png");
    const jb = require("../assets/newIcon/j_b.png");
    const mb = require("../assets/newIcon/m_b.png");
    const back = require("../assets/newIcon/back.png");
    const backb = require("../assets/newIcon/back_b.png");
    const jc = require("../assets/newIcon/j_c.png");
    const toTop = require("../assets/newIcon/toTop.png");
    const qr = require("../assets/newIcon/qr.png");
    const wxqr = require("../assets/newIcon/wxqr.png");
    const dyqr = require("../assets/newIcon/dyqr.png");
    // const fire = require("../assets/newIcon/hot.gif");

    return {
      IMAGE_API,
      active: 0,
      cooperation,
      phone,
      logo,
      showMask: false,
      showMaskButton: true,
      bannerList: [],
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      selectBtn: 0,
      today: "",
      tomorrow: "",
      afterTomorrow: "",
      jWeek: "",
      mWeek: "",
      hWeek: "",
      selectIndex: 0,
      backStatus: 0,
      isTop: true,
      // ---------------------------------
      j,
      m,
      jb,
      jc,
      mb,
      back,
      backb,
      toTop,
      qr,
      wxqr,
      dyqr,
      meetingListData: 10,
      page: 1,
      time: "", //上传时间,
      threeOptionsIndex: 0,
      type: "fire",
      tabIndex: 0,
      selcetDate: "",
      isTopPc: false,
      leftMenu: false, // 左边菜单
    };
  },
  computed: {
    isPhone() {
      return isMobile();
    },
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.scrollY) {
          //延时执行后当newValue等于window.scrollY，代表滚动结束
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
          this.showMaskButton = true;
        }
      }, 1000); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        this.showMaskButton = false;
      }
      if (!this.isPhone) {
        if (newValue > 290) {
          this.leftMenu = true;
        } else {
          this.leftMenu = false;
        }
      }
    },
  },

  mounted() {
    getBanner().then(({ data: { data } }) => {
      this.bannerList = data;
    });
    this.today = moment().format("MM月  DD日");
    this.jWeek = this.formatWeek(moment().format("d"));
    this.tomorrow = moment().add(1, "days").format("MM月  DD日");
    this.mWeek = this.formatWeek(moment().add(1, "days").format("d"));
    this.afterTomorrow = moment().add(2, "days").format("MM月  DD日");
    this.hWeek = this.formatWeek(moment().add(2, "days").format("d"));
    this.handleScroll();
  },
  methods: {
    backUrl() {
      window.open("http://www.medstudy.com.cn/");
    },
    //标签点击事件
    onClickTab(index) {
      if (index == "0") {
        //推荐
        this.isTop = true;
        this.time = "";
      } else {
        this.isTop = false;
        this.selectBtn = 0;
        this.threeOptionsIndex = 0;
      }
    },
    // 仅看今日
    onlyToDay(index) {
      if (this.selectBtn == index) {
        this.selectBtn = 0;
        this.time = "";
      } else {
        this.selectBtn = index;
        let time = transTimestamp(Date.now());
        this.time = time;

        let time1 = transTimestamp(this.time);
        // console.log(time1,this.time,'xianzai utc');
      }

      this.threeOptionsIndex = this.selectBtn;
    },

    // 仅看明日
    onlyTomorrow(index) {
      if (this.selectBtn == index) {
        this.selectBtn = 0;
        this.time = "";
      } else {
        this.selectBtn = index;
        let date = +new Date() + 24 * 60 * 60 * 1000;
        this.time = transTimestamp(date);
      }
      this.threeOptionsIndex = this.selectBtn;
    },
    // 直播回放
    onlyBack(index) {
      if (this.selectBtn == index) {
        this.selectBtn = 0;
      } else {
        this.selectBtn = index;
      }
      this.time = "";
      this.threeOptionsIndex = this.selectBtn;
      this.backStatus = 3;
      // this.$refs.allTab.getOnlyBackList();
      // 点击直播回顾 3 更新列表 而且是直播回顾的列表
    },
    // 数据页面渲染
    async getMeetingLists(time) {
      //待开播 0
      let { data: waiteData } = await getMeetingList({
        page: this.page,
        pageSize: 10,
        filterDate: time, //日期
        Status: [0], //状态
      });
      //直播中 1 2
      let { data: meetingData } = await getMeetingList({
        page: this.page,
        pageSize: 10,
        filterDate: time, //日期
        Status: [1, 2], //状态
      });
      //回放 3  结束 4
      let { data: backData } = await getMeetingList({
        page: this.page,
        pageSize: 10,
        filterDate: time, //日期
        Status: [3], //状态
      });
      // 全部数据
      this.meetingList = [
        ...waiteData.data,
        ...meetingData.data,
        ...backData.data,
      ];
      this.page = this.page + 1;
      // console.log(this.meetingList, "list");
      let data = this.formatList(this.meetingList);
      // console.log(this.leftList, "left");
      // console.log(this.rightList, "right");
    },
    goUrl(item) {
      addClickCount(item.id).then(() => {});
      if (!item.link) {
        this.$notify({ type: "primary", message: "没有二级页面" });
      } else {
        location.href = item.link;
      }
    },
    handleScroll() {
      window.addEventListener("scroll", () => {
        this.scrollTop = window.scrollY;
      });
    },
    changeBtn(index) {
      if (this.selectBtn == index) {
        this.selectBtn = 0;
      } else {
        this.selectBtn = index;
      }
    },
    // pcTab
    filterMeet(index) {
      this.selectIndex = index;
      this.tabIndex = index;
      if (index == 1) {
        //今日
        this.selcetDate = transTimestamp(Date.now());
      } else if (index == 2) {
        this.isTopPc = true;
        let date = +new Date() + 24 * 60 * 60 * 1000;
        this.selcetDate = transTimestamp(date);
      } else if (index == 3) {
        let date = +new Date() + 24 * 60 * 60 * 1000 + 24 * 60 * 60 * 1000;
        this.selcetDate = transTimestamp(date);
      } else {
        this.selcetDate = "";
      }
    },
    formatWeek(week) {
      switch (week) {
        case "1":
          return "星期一";
          break;
        case "2":
          return "星期二";
          break;
        case "3":
          return "星期三";
          break;
        case "4":
          return "星期四";
          break;
        case "5":
          return "星期五";
          break;
        case "6":
          return "星期六";
          break;
        case "0":
          return "星期日";
          break;
      }
    },
    backToTop() {
      // document
      //   .getElementById("right")
      //   .scrollTo(0, document.getElementById("pcList"));
      window.scrollTo(0, 0);
    },
    leave(e) {
      e.target.classList.add("leave");
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll); //离开当前组件移除事件监听
  },
};
</script>
<style lang="less" scoped>
.home {
  width: calc(100%);
  height: calc(100vh - 54px);
  padding-top: 27px;
  position: relative;

  .banner {
    // width: 691px;
    height: 259px;
    margin: 0 27px 0 27px;
    .my-swipe {
      width: 100%;
      height: 259px;
      border-radius: 8px;
      /deep/ .van-swipe__indicator {
        width: 16px;
        height: 16px;
      }
      .tabwaper {
        font-size: 32px !important;
      }
    }

    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #39a9ed;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .tabwaper {
    font-size: 32px !important;
    font-family: OPPOSans-B;
    font-weight: 500;
  }

  .subBtns {
    height: 52px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
    // box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3); /*上方无阴影*/
    padding-bottom: 14px;
    padding-top: 4px;
    position: sticky;
    top: 86px;
    z-index: 5;

    .subBtn {
      width: 224px;
      height: 52px;
      color: #999999;
      background: #f2f2f2;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: OPPOSans-M;

      img {
        width: 32px;
        height: 32px;
        margin-right: 12px;
      }
    }

    .subBtn--active {
      color: white;
      background: linear-gradient(135deg, #0095ff 0%, #34abff 100%);
    }
  }

  .cooperation {
    width: 80px;
    height: 80px;
    position: fixed;
    right: 0px;
    bottom: 200px;
    // background-color: rgba(95, 135, 164, 0.18);
    border-radius: 80px 0 0 80px;
    display: flex;
    // opacity: 0.75;
    align-items: center;
    transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);
    backdrop-filter: blur(20px) saturate(180%);
    background-color: #e8f2f9e6;


    img {
      width: 54px;
      height: 48px;
      margin: 0 auto;
    }
  }

  .transright {
    transform: translate(50px, 0px);
    width: 80px;
    height: 80px;
    position: fixed;
    right: 0px;
    bottom: 200px;
    backdrop-filter: blur(20px) saturate(180%);
    background-color: #e8f2f9e6;
    border-radius: 80px 0 0 80px;
    display: flex;
    align-items: center;
    transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);

    img {
      width: 54px;
      height: 48px;
      margin: 0 auto;
      margin: 0 auto;
    }
  }

  fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s;
  }

  .fade-enter,
    .fade-leave-to

    /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fade-enter-active {
    transition: opacity 0.25s;
  }
}

/deep/ .van-tabs {
  width: 100%;
  margin-top: 20px;
  .van-tab__text--ellipsis {
    font-size: 32px !important;
  }
  .van-sticky--fixed {
    // width: calc(100% - 50px);
    margin: auto;
  }
  
  .van-tabs__wrap {
    font-size: 16px;
    height: 86px;
    font-family: OPPOSans-B;
    box-shadow: 0px -6px 6px  rgba(0, 0, 0, 0.08);
    border-radius: 32px 32px 0px 0px;
    .van-tabs__nav--line{
      padding-bottom: 22px;
    }
    .van-tabs__nav{
      height: 64px;
    }
    .van-tabs__line {
      width: 28px;
      height: 7px;
      margin-top: 8px;
    }
  }

  .van-tab--active {
    font-family: OPPOSans-B;

    .van-tab__text--ellipsis {
      font-size: 32px;
    }
  }

  .van-tab__text--ellipsis {
    font-size: 26px;
  }

  .van-tabs__content {
    min-height: 1300px !important;
    .van-list {
      margin: 0 27px 0 27px;
    }
  }
  .van-tabs__content .van-tab__pane:nth-child(2) {
    margin: 0 !important;
  }
  .van-tab {
    line-height: unset;

    .van-tabs__content {
      height: calc(100% - 70px);

      .van-tab__pane {
        height: 100%;
        margin-bottom: 14px !important;
      }
    }
  }
}

/deep/ .van-popup {
  background-color: rgba(255, 255, 255, 0.9);

  .swhz {
    font-size: 30px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-top: 65px;
  }

  .num {
    font-size: 30px;
    color: #333333;
    text-align: center;
    margin: 25px 0 40xp 0;
  }

  .phoneImg {
    margin: 0 328px;
    width: 94px;
    height: 94px;
  }
}

/deep/ .van-empty {
  .van-empty__description {
    font-size: 24px;
  }
}
</style>

<style lang="less" scoped>
.nav {
  width: 100vw;
  height: 113px;
  box-sizing: border-box;
  padding: 0 calc((100vw - 1280px) / 2);
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 8px 80px 0px rgba(0, 64, 103, 0.1);
  position: fixed;
  top: 0;
  z-index: 999;
  background-color: #fffffff2;
  // opacity: o.95;
  font-family: OPPOSans-R;
  color: #bcd4e6;
  font-size: 26px;
  backdrop-filter: blur(20px) saturate(180%);
  .nav_left {
    display: flex;
    align-items: center;

    .logo {
      height: 51px;
      // height: 70px;
      img {
        width: 127px;
        height: 51px;
      }
    }

    .line {
      width: 1.5px;
      height: 51px;
      background: #dfe9f1;
      margin: 0 28px;
    }

    .title {
      cursor: pointer;
    }
  }

  .nav_right {
    .back {
      cursor: pointer;
    }

    .back:hover {
      color: #0091ff;
      // transition: all 0.3s Cubic-Bezier(0.4, 0, 0.4, 1);
    }
  }
}

.leave {
  transition: all 0.6s Cubic-Bezier(0.4, 0, 0.4, 1);
}
.pc {
  .banner {
    height: 343px;
    width: 1500px;
    margin: 143px auto 28px;
    // margin-bottom:28px ;
  }
}

main {
  width: 1280px;
  margin: 0 auto;

  .meetList {
    width: 100%;
    // height: calc(100vh - 480px);
    // max-height: 700px;
    max-height: 700px;
    display: flex;
    justify-content: space-between;

    .leftMenu {
      position: fixed;
      top:142px;
      // left: 715px;
    }

    .left {
      width: 200px;
      flex-shrink: 0;
      align-self: flex-start;
      box-shadow: 0px 8px 80px 0px rgba(0, 64, 103, 0.1);
      font-family: OPPOSans-B;
      color: #0f3358;
      border-radius: 0px 8px 8px 0px;

      .left_item {
        box-sizing: border-box;
        width: 100%;
        height: 85px;
        font-size: 24px;
        padding-left: 20px;
        // color: black;
        display: flex;
        flex-wrap: wrap;
        // align-items: center;
        align-content: center;
        border-left: 6px solid rgba(0, 145, 255, 0.2);
        background-color: #fff;

        cursor: pointer;

        p {
          width: 100%;
          flex-shrink: 0;
          margin: 0;

          img {
            width: 20px;
            height: 20px;
            margin-left: 10px;
          }
        }

        span {
          font-size: 12px;
          color: #999999;
          font-weight: normal;
          font-family: OPPOSans-R;
        }
      }

      .fire {
        width: 35px !important;
        height: 25px !important;
        vertical-align: bottom;
      }

      .left_item:hover {
        border-left: 6px solid #0091ff;
        background-color: rgba(0, 145, 255, 0.2);
        transition: all 0.6s Cubic-Bezier(0.4, 0, 0.4, 1);
      }
      .left_item_active {
        width: 100%;
        color: #0091ff;
        border-left: 6px solid #0091ff;
        background: linear-gradient(
          180deg,
          rgba(50, 165, 255, 0.2) 0%,
          rgba(50, 165, 255, 0.05) 100%
        );
      }
    }

    .rightMar {
      margin-left: 220px;
    }

    .right {
      width: calc(100% - 220px);
      // height: 100%;
      min-height: 1300px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // overflow-y: scroll;

      .right_item {
        width: 520px;
        height: 140px;
        display: flex;
        background-color: #999999;
        opacity: 0.2;
        box-shadow: 0px 8px 80px 0px rgba(0, 64, 103, 0.1);
        margin-bottom: 10px;

        img {
          width: 200px;
        }

        .meetInfo {
          width: 325px;
        }
      }
    }

    .right::-webkit-scrollbar {
      width: 10px;
    }

    .right::-webkit-scrollbar-thumb {
      background: #ccc; // 滑块颜色
      border-radius: 5px; // 滑块圆角
    }

    .right::-webkit-scrollbar-thumb:hover {
      background: #f40; // 鼠标移入滑块变红
    }
  }
}
</style>
<style lang="less">
.backTop {
  width: 60px;
  height: 150px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  > div:hover {
    background-color: #dfe9f1;
  }

  > div {
    position: relative;
    transition: all 1s;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;

    > img {
      width: 40px;
      height: 40px;
    }

    .show {
      display: none;

      // opacity: 0;
      .hoverdiv {
        width: 300px;
        height: 200px;
        background: #ffffff;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
        position: absolute;
        left: -320px;
        bottom: -50px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        > div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          > img {
            width: 150px;
            height: 150px;
            margin-bottom: 5px;
          }

          p {
            margin: 0;
          }
        }
      }
    }
  }

  .qr:hover .show {
    display: unset;
    // opacity: 1;
  }
}
</style>
